import { render, staticRenderFns } from "./ManagementSystem.vue?vue&type=template&id=5615ffa0&scoped=true&"
import script from "./ManagementSystem.vue?vue&type=script&lang=js&"
export * from "./ManagementSystem.vue?vue&type=script&lang=js&"
import style0 from "./ManagementSystem.vue?vue&type=style&index=0&id=5615ffa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5615ffa0",
  null
  
)

export default component.exports